document.addEventListener('DOMContentLoaded', function () {
    let currentAudio = null;
    let currentPlayIcon = null;
    let currentPauseIcon = null;
    let currentCircle = null;
    let updateInterval = null;
    const audioMap = new Map(); // Карта для хранения аудио объектов для каждой кнопки

    function updateIcons(playIcon, pauseIcon, isPlaying) {
        if (isPlaying) {
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'flex';
        } else {
            playIcon.style.display = 'flex';
            pauseIcon.style.display = 'none';
        }
    }

    function updateProgressCircle(audio, circle) {
        const duration = audio.duration;
        const currentTime = audio.currentTime;
        const progress = (currentTime / duration) * 138; // Вычисляем прогресс в зависимости от времени (новый периметр)
        circle.style.strokeDashoffset = 138 - progress; // Обновляем длину штриха
    }

    function resetProgressCircle(circle) {
        circle.style.strokeDashoffset = 138; // Сброс к исходному состоянию
    }

    // Делегируем событие клика на родительский элемент
    document.body.addEventListener('click', function (event) {
        const btn = event.target.closest('.play-sound-btn');
        if (btn) {
            const wrapperDiv = btn.closest('.play-sound-btn__wrapper');
            const soundUrl = wrapperDiv ? wrapperDiv.getAttribute('data-sound-url') : null;
            const playIcon = btn.querySelector('.play-icon');
            const pauseIcon = btn.querySelector('.pause-icon');
            const progressCircle = btn.querySelector('.progress-ring__circle');

            if (soundUrl) {
                // Проверяем, существует ли уже аудио для этого soundUrl
                let audio = audioMap.get(soundUrl);

                if (!audio) {
                    audio = new Audio(soundUrl);
                    audioMap.set(soundUrl, audio); // Сохраняем объект аудио в карту
                }

                if (audio.paused) {
                    if (currentAudio && !currentAudio.paused) {
                        currentAudio.pause();
                        updateIcons(currentPlayIcon, currentPauseIcon, false);
                        resetProgressCircle(currentCircle); // Сброс прогресса для предыдущего аудио
                        clearInterval(updateInterval);
                    }

                    audio.play().then(() => {
                        updateIcons(playIcon, pauseIcon, true);

                        currentAudio = audio;
                        currentPlayIcon = playIcon;
                        currentPauseIcon = pauseIcon;
                        currentCircle = progressCircle;

                        updateInterval = setInterval(() => {
                            updateProgressCircle(audio, progressCircle);
                        }, 100); // Обновляем прогресс каждые 100 мс
                    }).catch(function (error) {
                        console.error('Error playing audio file', error);
                    });
                } else {
                    audio.pause();
                    updateIcons(playIcon, pauseIcon, false);
                    clearInterval(updateInterval);
                }

                audio.addEventListener('ended', function () {
                    updateIcons(playIcon, pauseIcon, false);
                    resetProgressCircle(progressCircle); // Сброс прогресса после завершения
                    clearInterval(updateInterval);

                    if (currentAudio === audio) {
                        currentAudio = null;
                        currentPlayIcon = null;
                        currentPauseIcon = null;
                        currentCircle = null;
                    }
                });
            } else {
                console.error('No sound URL provided');
            }
        }
    });
});
